import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ExchangeRateWrapper = styled.div`
  padding: ${Spacing.S8};
  border-radius: ${Spacing.S8};
  background-color: ${Color.Grey100};
`

export const ExchangeRateInfoWrapper = styled.div`
  cursor: pointer;
`
